import { render, staticRenderFns } from "./select-member.vue?vue&type=template&id=28472bd6&"
import script from "./select-member.vue?vue&type=script&lang=js&"
export * from "./select-member.vue?vue&type=script&lang=js&"
import style0 from "./select-member.vue?vue&type=style&index=0&id=28472bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports